import { typedPageSelectors, usePage } from 'publisher/store'
import React from 'react'
import { CommonPublisherButtonEntityOrSubEntity } from 'src/publisher/shared/components/button/common-publisher-button-entity-or-sub-entity'
import { LoginButtonEntityInterface } from 'src/shared/entities/login-button/login-button-entity.schema'

const TEST_ID = 'login-button'

export interface LoginButtonProps {
  entity: LoginButtonEntityInterface
}

export const LoginButton = ({ entity }: LoginButtonProps) => {
  const locale = usePage(state => typedPageSelectors.getLocale(state))

  return (
    <CommonPublisherButtonEntityOrSubEntity
      entityOrSubEntity={entity}
      onClick={() => {
        location.assign(`/${locale}/login`)
      }}
      testId={TEST_ID}
    />
  )
}
